import React, {useEffect, useState} from 'react';
import {Dropdown, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import moment from 'moment';

import {
    couponsCreateService,
    couponsDeleteService,
    couponsListService,
    couponsUpdateService
} from '../../services/couponService';
import {Loader} from '../../components/util/Svg';
import Breadcrumb from '../../components/Breadcrumb';
import {DatePicker} from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'


const Coupons = () => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [createModal, setCreateModal] = useState(false);
    const [couponName, setCouponName] = useState('');
    const [couponNameErr, setCouponNameErr] = useState('');
    const [duration, setDuration] = useState('');
    const [durationErr, setDurationErr] = useState('');
    const [durationInMonth, setDurationInMonth] = useState('');
    const [durationInMonthErr, setDurationInMonthErr] = useState('');
    const [percentOff, setPercentOff] = useState('');
    const [percentOffErr, setPercentOffErr] = useState('');
    const [maxRedemption, setMaxRedemption] = useState('');
    const [maxRedemptionErr, setMaxRedemptionErr] = useState('');
    const [redeemBy, setRedeemBy] = useState('');
    const [redeemByErr, setRedeemByErr] = useState('');
    const [typeErr, setTypeErr] = useState('');
    const [type, setType] = useState('');
    const [editTypeErr, setEditTypeErr] = useState('');
    const [editType, setEditType] = useState(false);
    const [emails, setEmails] = useState('');
    const [emailErr, setEmailErr] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [currentId, setCurrentId] = useState('');


    const breadcrumb = [
        {link: '', linkText: 'Coupons'}
    ]


    const handleClose = () => {
        setCreateModal(false);
        setCouponName();
        setCouponNameErr();
        setDuration();
        setDurationErr();
        setPercentOff();
        setPercentOffErr();
        setMaxRedemption();
        setMaxRedemptionErr();
        setRedeemBy();
        setRedeemByErr();
        setDurationInMonth();
        setDurationInMonthErr();
        setEmails();
        setEmailErr();
        setCurrentId('');
        setTypeErr('');
setEditType(false)
    }


    const getList = () => {
        let params = ``;
        couponsListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.list)


            }
        })
    }


    useEffect(() => {
        getList();
    }, [])



    const handleValidate = () => {
        let validate = true;
        if(editType) {
            if (type == '') {
                setTypeErr('type is required');
                validate = false

            }
        }else {
            if (couponName == '' || couponName == undefined) {
                setCouponNameErr('Coupon name is required');
                validate = false
            }

            if (duration == '' || duration == undefined) {
                setDurationErr('Duration is required');
                validate = false

            } else if (duration == 'repeating' && (durationInMonth == "" || durationInMonth == undefined)) {
                setDurationInMonthErr('Duration in month is required');
                validate = false

            } else {
                setDurationInMonthErr('')
                setDurationErr('')
            }
            if (type == '') {
                setTypeErr('type is required');
                validate = false

            }
            if (percentOff == '' || percentOff == null || percentOff == undefined) {
                setPercentOffErr('Percent off is required');
                validate = false

            }
        }

        return validate;
    }


    const handleSubmit = e => {
        e.preventDefault();
        if (handleValidate()) {
            setIsDisabled(true);
            let params = {};
            // if (currentId) {            }
          if(editType||currentId){

              params = {

                  'emails': emails,
                  'type': type,
                  'name': couponName,
                  'couponId': currentId ? currentId : '',

              }
          }
            else{
                params = {

                'emails': emails,
                'type': type,
                'redeemBy': redeemBy?redeemBy/1000:'',
                'maxRedemptions': maxRedemption?maxRedemption:0,
                'percentOff': percentOff,
                'durationInMonths': durationInMonth?durationInMonth:'',
                'duration': duration,
                'name': couponName,
                'couponId': currentId ? currentId : '',

            }
            }

            let _service = currentId ? couponsUpdateService : couponsCreateService;

            _service(params).then(res => {
                // setEditType(false)
                setCurrentId('')
                setIsDisabled(false);
                if (res.status) {
                    handleClose();
                    getList();
                }
            })
        }

    }


    const handleDelete = couponId => {

        setLoader(true);

        // let tempList = list.filter(i => i._id != couponId);
        // setList(tempList);
        let params = {couponId}
        couponsDeleteService(params).then(res => {
            setLoader(false);

            if (res.status == 1) {
                getList()
            }
        })
    }


    const handleEdit = (item,type) => {
        setCreateModal(true);
         setEditType(true);
         setType(item.metadata.type);
        setCouponName(item.name);
        setEmails(item.metadata.emails);
        setCurrentId(item.id);
    }
    const handleDateChange = (date, dateString) => {

        let dates = new Date()
        setRedeemByErr('');


        let interval1 = moment(date).toDate().setTime(moment(date).toDate().getTime())
        interval1 = Math.floor(interval1 / 1000)
        setRedeemBy(interval1*1000)

    }

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    const dateTimeFormat = (val) => {
        let data = moment(val *1000).format("DD/MM/YYYY")

        return data;

    }

    const showAdditional = (additional) => {
        let jsx = [];
        additional.length && additional.map((val, i) => {

            jsx.push(<span id={"989i890"}>{val}{i < additional.length ? "," : ""} </span>)
        })
        return jsx;

    }

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <input type="text" className="form-control" placeholder="Search"/>
                <i className="fa fa-search"/>

                <button className="btn btn-primary btn-sm">Search</button>
            </div>

            <Breadcrumb breadcrumb={breadcrumb}/>

            <div className="justifydesign d-flex justify-content-between align-content-center page_header">
                <h2>Coupon List</h2>
                <span className="btn btn-primary" onClick={() => setCreateModal(true)}>Create</span>
            </div>


            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                {loader ? <div className="loader_lg"><Loader/></div> : ''}
                <table className="table user-table table-hover align-items-center">
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Created On</th>
                        <th>Coupon Id</th>
                        <th>Coupon Name</th>
                        <th>Percent off</th>
                        <th>Duration</th>
                        <th>Duration in mon.</th>
                        <th>Max redemption</th>
                        <th>Times redeemed</th>
                        <th>Redeem By</th>
                        <th>Assign To</th>
                        <th>Type</th>
                        <th>Valid</th>
                        <th>Action</th>


                    </tr>
                    </thead>
                    <tbody>
                    {list.map((item, i) => (
                        <tr key={item._id}>
                            <td>{i + 1}</td>
                            <td>{moment(item.created*1000).format('DD MMM, YYYY')}</td>
                            <td>{item.id}</td>
                            {/*<td><input className="remove-input-border" type="text" value= {item.id} onClick={()=>getCode()}/></td>*/}

                            <td>{item.name} </td>
                            <td>{item.percent_off} </td>
                            <td>{item.duration?item.duration:''} </td>
                            <td>{item.duration_in_months?item.duration_in_months:''} </td>
                            <td>{item.max_redemptions?item.max_redemptions:''} </td>
                            <td>{item.times_redeemed?item.times_redeemed:''} </td>
                            <td>{item.redeem_by?dateTimeFormat(item.redeem_by):''} </td>
                            <td>{item.metadata.emails} </td>
                            <td>{item.metadata.type == 1 ? "Subscription" : (item.metadata.type == 2 ? "Credit Pack" : (item.metadata.type == 3 ? "Both" : ""))} </td>
                            <td>{item.valid ? "true" : "false"} </td>
                            <td>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle className="no_btn"><i className="ellipsis-h"/></Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleEdit(item,1)}>Edit</Dropdown.Item>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleDelete(item.id)}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>


            <Modal
                show={createModal}
                onHide={handleClose}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Coupon Name</label>

                            <input
                                className={`form-control ${couponNameErr ? 'is-invalid' : ''} rounded-pill`}
                                type="text"
                                maxLength={"40"}
                                value={couponName}
                                onChange={e => (setCouponName(e.target.value), setCouponNameErr(''))}
                                placeholder="Enter coupon name"/>

                            {couponNameErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{couponNameErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>
                        {editType?'':  (
                            <>


                        <div className="form-group">
                            <label>Percent off</label>

                            <input
                                className={`form-control ${percentOffErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                value={percentOff}
                                maxLength="3"
                                max={"100"}
                                onChange={e => (setPercentOff(e.target.value), setPercentOffErr(''))}
                                placeholder="Enter percent off"/>

                            {percentOffErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{percentOffErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>


                        <div className="form-group">
                            <label>Duration</label>
                            <select
                                value={duration}
                                onChange={e => (setDuration(e.target.value), setDurationErr(''), e.target.value == "repeating" ? '' : setDurationInMonth(''))}
                                className={`form-control ${durationErr ? 'is-invalid' : ''} rounded-pill`}>

                                <option selected>Choose...</option>
                                <option value="forever">forever</option>
                                <option value="once">once</option>
                                <option value="repeating">repeating</option>
                            </select>


                            {durationErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{durationErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>

                        {duration == "repeating" ? <div className="form-group">
                            <label>Duration In Month</label>

                            <input
                                className={`form-control ${durationInMonthErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                value={durationInMonth}
                                onChange={e => (setDurationInMonth(e.target.value), setDurationInMonthErr(''))}
                                placeholder="Enter duration in month"/>


                            {durationInMonthErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{durationInMonthErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div> : ''}


                        <div className="form-group">
                            <label>Max redemption</label>

                            <input
                                className={`form-control ${maxRedemptionErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                max={"500000"}
                                value={maxRedemption}
                                onChange={e => (setMaxRedemption(e.target.value), setMaxRedemptionErr(''))}
                                placeholder="Enter max redemption"/>

                            {maxRedemptionErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{maxRedemptionErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>
                            </>
                        )}

                        <div className="form-group">
                            <label>Assign To </label>

                            <textarea
                                className={`form-control ${emailErr ? 'is-invalid' : ''}`}
                                type="text"
                                value={emails}
                                onChange={e => (setEmails(e.target.value), setEmailErr(''))}
                                placeholder="Enter emails"/>

                            {emailErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{emailErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>
                        {editType?'':  (
                            duration=="forever"?"" :(<> <div className="form-group">
                            <label>Redeem By</label>

                            {/*<input*/}
                            {/*    className={`form-control ${redeemByErr ? 'is-invalid' : ''} rounded-pill`}*/}
                            {/*    type="text"*/}
                            {/*    value={redeemBy}*/}
                            {/*    onChange={e => (setRedeemBy(e.target.value), setRedeemByErr(''))}*/}
                            {/*    placeholder="Enter redeem by"/>*/}


                          <DatePicker
                                allowClear={false}
                                value={redeemBy ? moment(redeemBy) : ''}
                                defaultValue={moment(redeemBy) ? moment(redeemBy) : 'Select date'}
                                className={`form-control ${redeemByErr ? 'is-invalid' : ''} rounded-pill`}
                                onChange={handleDateChange}
                                disabledDate={disabledDate}

                                // format={dateFormat}

                            />

                            {redeemByErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{redeemByErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div></>))}
                        <div className="form-group">
                            <label>Type</label>

                            <select
                                value={type}
                                onChange={e => (setType(e.target.value), setTypeErr(''))}
                                className={`form-control ${typeErr ? 'is-invalid' : ''} rounded-pill`}>

                                <option selected>Choose...</option>
                                {/*<option value="1">For subscription</option>*/}
                                <option value="2">For Credit Pack</option>
                                {/*<option value="3">For Both</option>*/}
                            </select>


                            {typeErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{typeErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>


                        <div className="text-center mt-3">
                            <button disabled={isDisabled} type="submit"
                                    className="btn btn-primary rounded-pill pl-5 pr-5">Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Coupons;